import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  trackAppError() {
    const errorCode = this.element.dataset.errorCode;
    const errorMessage = this.element.dataset.errorMessage;
    const pageUrl = window.location.href;
    const referrer = document.referrer;

    if (window.amplitude && window.amplitude.logEvent) {
      window.amplitude.logEvent("App error", {
        error_code: errorCode,
        error_message: errorMessage,
        page_url: pageUrl,
        referrer: referrer
      });
    }
  }
}
